import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControlLabel,
    Switch,
    Button,
    Box
} from '@mui/material';

function UsuarioForm({ open, onClose, usuario, onSave }) {
    const [formData, setFormData] = useState({
        fullName: '',
        userName: '',
        email: '',
        password: '',
        enabled: true,
        tenantsAllowed: ''
    });

    const isEditMode = usuario && usuario._id;

    useEffect(() => {
        if (usuario) {
            setFormData({
                ...usuario,
                fullName: usuario.fullName || '',
                userName: usuario.userName || '',
                email: usuario.email || '',
                password: '',
                enabled: usuario.enabled !== undefined ? usuario.enabled : true,
                tenantsAllowed: Array.isArray(usuario.tenantsAllowed)
                    ? usuario.tenantsAllowed.map(t => t.value).join(' , ')
                    : usuario.tenantsAllowed || ''
            });
        } else {
            setFormData({
                fullName: '',
                userName: '',
                email: '',
                password: '',
                enabled: true,
                tenantsAllowed: ''
            });
        }
    }, [usuario, open]);

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = () => {
        const dataToSave = { ...formData };
        if (isEditMode && !dataToSave.password) {
            delete dataToSave.password;
        }
        onSave(dataToSave);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ backgroundColor: '#3d4d87', color: 'white' }}>
                {isEditMode ? 'Editar Usuario' : 'Nuevo Usuario'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <TextField
                        label="Nombre Completo"
                        value={formData.fullName}
                        onChange={(e) => handleChange('fullName', e.target.value)}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Usuario"
                        value={formData.userName}
                        onChange={(e) => handleChange('userName', e.target.value)}
                        fullWidth
                        required
                        disabled={isEditMode}
                    />
                    <TextField
                        label="Email"
                        type="email"
                        value={formData.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label={isEditMode ? "Nueva Clave (dejar vacío para mantener)" : "Clave"}
                        type="password"
                        value={formData.password}
                        onChange={(e) => handleChange('password', e.target.value)}
                        fullWidth
                        required={!isEditMode}
                    />
                    <TextField
                        label="Tenants Permitidos (separados por coma)"
                        value={formData.tenantsAllowed}
                        onChange={(e) => handleChange('tenantsAllowed', e.target.value)}
                        fullWidth
                        helperText="Ej: TENANT1 , TENANT2"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={formData.enabled}
                                onChange={(e) => handleChange('enabled', e.target.checked)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#3d4d87',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#3d4d87',
                                    },
                                }}
                            />
                        }
                        label="Activo"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <Button onClick={onClose} sx={{ color: '#666' }}>
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{ backgroundColor: '#3d4d87', '&:hover': { backgroundColor: '#2d3d67' } }}
                >
                    {isEditMode ? 'Guardar Cambios' : 'Crear'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UsuarioForm;
